<template>
  <div class="appNav" v-bar>
    <div class="appNav-main">
      <el-menu
        mode="vertical"
        :default-active="routePath"
        :show-timeout="200"
        :collapse="navCtrl"
        background-color="#BF735B"
        text-color="#fff"
        active-text-color="#EDB9A9"
        class="el-menu-vertical-demo"
        @select="selectMenu"
        router
      >
        <MenuItemRecursive
          v-for="item in routers"
          :key="item.name"
          :item="item"
          :base-path="''"
        />
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MenuItemRecursive from "./MenuItemRecursive.vue";

export default {
  components: {
    MenuItemRecursive
  },
  computed: {
    ...mapGetters(["routers", "userInfo", "navCtrl", "language"]),
    routePath() {
      let path;
      if (this.$route.meta.hidden) {
        let router = this.$route.path.split("/", 3);
        path = `/${router[1]}/${router[2]}`;
      } else {
        path = this.$route.path;
      }
      return path;
    },
  },
  data() {
    return {
      routerRole: [],
    };
  },
  methods: {
    selectMenu() {
      if (localStorage.getItem("page")) {
        localStorage.removeItem("page");
      }
    },
  },
};
</script>
<style lang="scss">
.appNav {
  height: 100%;
  .appNav-main {
    padding-right: 0 !important;
    .el-menu-vertical-demo:not(.el-menu--collapse) {
      width: 220px;
      min-height: 400px;
    }
    .el-menu-vertical-demo {
      height: 100%;
    }
    .el-menu--collapse {
      height: 100%;
    }
    .el-menu {
      border-right: 0;
    }

    .app_nav_icon {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    .el-icon-arrow-down:before {
      content: none;
    }
    .el-submenu__icon-arrow {
      width: 12px;
      height: 12px;
      right: 30px;
      background: url("~@/assets/img/cmb_pack_up.png") no-repeat center;
    }
    .el-menu-item {
      div:before {
        content: "";
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #fff;
        border-radius: 50%;
        margin-right: 10px;
        transition: all 0.3s linear;
      }
      &:hover {
        background-color: $globalLessBGColor !important;
      }
    }

    .el-submenu {
      overflow: hidden;
      > .el-submenu__title:hover {
        background-color: $globalLessBGColor !important;
      }
    }

    .el-submenu.is-opened {
      > .el-submenu__title .el-submenu__icon-arrow {
        transform: rotateZ(90deg);
      }
    }

    .el-submenu.is-active {
      > .el-submenu__title {
        background: $globalLessBGColor !important;
      }
      > .el-submenu__title::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background: $globalLeastBGColor;
      }
      .is-active {
        span:before {
          background: $globalLeastBGColor;
        }
      }
    }
    
    .submenu-item-title {
      display: inline-block;
      width: 120px;
      max-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    
    // 支持多级菜单的嵌套样式
    .el-submenu .el-submenu {
      .el-submenu__title {
        padding-left: 40px !important;
      }
    }
    
    .el-submenu .el-submenu .el-submenu {
      .el-submenu__title {
        padding-left: 60px !important;
      }
    }
    
    .el-submenu .el-menu-item {
      min-width: auto;
    }
  }
}

.el-menu--vertical {
  .el-menu-item:hover {
    background-color: $globalLessBGColor !important;
  }
}
</style>
